import {
  CancelSubscriptionRequest,
  CancelSubscriptionResponse,
  HttpMethod,
  SubscriptionActiveAction,
} from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';

export function useCancelSubscriptionMutationApi(
  id?: string,
  action?: SubscriptionActiveAction
) {
  const endpoint = useCustomerEndpoint('subscription');

  return useBaseMutation<CancelSubscriptionRequest, CancelSubscriptionResponse>(
    {
      url: `${endpoint}/${id}`,
      method: HttpMethod.delete,
      params: { action },
    },
    {
      onSuccess: () => {
        baseQueryClient.invalidateQueries([useCurrentSubscriptionApi.name]);
      },
    }
  );
}
